export function isMultilineEditor(node:Element) {
  if (!node) {
    return false;
  }

  return node.tagName.toLowerCase() == 'textarea';
}
